import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const agregarPackACarrito = async (clienteId, packId, cantidad, token, packData = null) => {
	const body = {
		userId: clienteId,
		productoId: packId, // El backend usa productoId para el packId
		cantidad: cantidad,
	};

	// Si se proporciona packData con adicionales, incluirlos en el body
	if (packData && packData.productos) {
		body.productosConAdicionales = packData.productos.map((producto) => ({
			productoId: producto.id,
			adicionalSeleccionado: producto.adicionalSeleccionado || 0,
		}));
		body.precioConAdicionales = packData.precioConAdicionales;
	}

	try {
		const response = await apiClient.post('/carrito/agregarPackACarrito', body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Se produjo un error desconocido.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
